<template>
  <div>
    <div style="width:21cm; margin: 0 auto">
      <el-button class="printBtn" type="primary" style="margin: 2mm auto" @click="printHandle">打印</el-button>
    </div>
    <div id="print">
      <div class="print-template">
        <!-- 标题部分 -->
        <div class="title-section">
          <h1>新时达工控技术（杭州）有限公司</h1>
          <h2>新时达标准采购订单</h2>
        </div>
        
        <!-- 订单基本信息 -->
        <div class="order-info">
          <div class="info-row">
            <div class="info-column">
              <div class="info-item">
                <span class="label">甲方:</span>
                <span class="value">新时达工控技术（杭州）有限公司</span>
              </div>
              <div class="info-item">
                <span class="label">联系人:</span>
                <span class="value">{{contract.buyUserName}}</span>
              </div>
              <div class="info-item">
                <span class="label">联系电话:</span>
                <span class="value">{{contract.contractNo}}</span>
              </div>
            </div>
            
            <div class="info-column">
              <div class="info-item">
                <span class="label">乙方:</span>
                <span class="value">{{contract.gysName}}</span>
              </div>
              <div class="info-item">
                <span class="label">联系人:</span>
                <span class="value">{{contract.linkMan}}</span>
              </div>
              <div class="info-item">
                <span class="label">联系电话:</span>
                <span class="value">{{contract.linkManPhone}}</span>
              </div>
            </div>
            
            <div class="info-column">
              <div class="info-item">
                <span class="label">采购订单号:</span>
                <span class="value">{{contract.buyOrderNo}}</span>
              </div>
              <div class="info-item">
                <span class="label">订单日期:</span>
                <span class="value">{{contract.addDate ? contract.addDate.slice(0, 10) : ''}}</span>
              </div>
              <div class="info-item">
                <span class="label">签订地:</span>
                <span class="value">浙江省杭州市余杭区</span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 物料表格 -->
        <div class="material-table">
          <table>
            <thead>
              <tr>
                <th>序号</th>
                <th>物料代码</th>
                <th>旧料号</th>
                <th>物料名称</th>
                <th>规格型号</th>
                <th>单位</th>
                <th>数量</th>
                <th>未税单价</th>
                <th>未税总额</th>
                <th>交货日期</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in contract.details" :key="index">
                <td>{{index + 1}}</td>
                <td>{{item.partNo}}</td>
                <td>{{item.mappingMaterialNo || ''}}</td>
                <td style="width: 180px;text-align: left;">{{item.partNameSpec}}</td>
                <td>{{item.specification}}</td>
                <td>{{item.unit || 'PC'}}</td>
                <td>{{item.qty}}</td>
                <td>{{item.unitPrice}}</td>
                <td>{{item.price}}</td>
                <td>{{item.requireDeliveryDate ? item.requireDeliveryDate.slice(0, 10) : ''}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="3" rowspan="2" class="total-label">合计</td>
                <td colspan="7" class="total-value">
                  <div>小写: {{contractItemsTotalPrice}}</div>
                </td>
              </tr>
              <tr>
                <td colspan="7" class="total-value">
                  <div>大写: {{contractItemsTotalPriceUpper}}</div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        
        <!-- 备注信息 -->
        <div class="remarks">
          <div class="remark-item">
            包装方式：符合业界标准及甲方要求
          </div>
          <div class="remark-item">
            送货文件必须包含制造商的出厂检验合格报告，必要时提供相关产品的认证证书或甲方要求乙方提供的其他单证
          </div>
          <div class="remark-item">
            送货地址：浙江省杭州市余杭区闲兴路35号4号楼1楼仓库
          </div>
          <div class="remark-item">
            1.技术质量标准：所供产品须为原装合格品(或根据甲方图纸、工艺定制)，符合甲方确认的各项技术指标要求：质量应符合国家和相应标准和甲方质量要求，严禁假冒伪劣，一经发现，乙方须承担为此造成的所有损失并支付相关赔偿给甲方，甲方保留追究乙方法律责任的权利。
          </div>
          <div class="remark-item">
            2.货物验收：货到5个工作日内甲方进行验收确认，若有质量问题甲方有权在验收后30天内提出异议。乙方材料在甲方入厂后出现产品质量异常乙方不能及时处理而委托甲方检验、筛选、或返工返修的全部费用由乙方承担（如双方已签署质量保证协议，则按甲乙双方签订的质量保证协议文件赔偿）。
          </div>
          <div class="remark-item">
            3.其它约定：乙方须按本采购订单约定的数量和日期交货，附送货单（一式两联）：送货单上须注明采购单号、物料代码、物料名称、规格型号、送货数量等信息。
          </div>
          <div class="remark-item">
            4.未经甲方书面同意，乙方回签本订单时所作出的任何单方面增删修订均无效，乙方仍应按甲方发出之订单内容履行义务。
          </div>
          <div class="remark-item">
            5.乙方应于收到本订单后一个工作日内予以确认并盖章回传，否则视为默认同意。
          </div>
          <div class="remark-item">
            6.若延期交货，每延期一天罚款本采购订单总金额的1%的违约金，其余双方友好协商，协商不成则提交合同签订所在地人民法院诉讼解决。
          </div>
          <div class="remark-item">
            7.其他未尽事宜，按补充协议和采购框架合同条款执行：以下交易文件内容冲突时的适用顺序为：（1）本采购订单；（2）补充协议如质量保证协议/技术协议：（3）采购框架合同。
          </div>
          <div class="remark-item">
            8.本合同一式贰份，甲乙双方各执壹份，双方签字或盖章后生效，传真件具有同等法律效力。
          </div>
        </div>
        
        <!-- 签字盖章部分 -->
        <div class="signature-section">
          <div class="signature-column">
            <div class="signature-title">甲方(盖章):</div>
            <div class="signature-info">
              <div>采购经办:</div>
              <div>审核: 王荣仙</div>
            </div>
          </div>
          <div class="signature-column">
            <div class="signature-title">乙方(盖章):</div>
            <div class="signature-info">
              <div>委托代理人:</div>
              <div>审核:</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import toChineseRMB from "@/util/toChineseRMB.js";
  export default {
    data() {
      return {
        contract: {
          orderInfo: {},
          details: [],
        },
      };
    },
    computed: {
      // 合同明细总价
      contractItemsTotalPrice() {
        const details = (this.contract && Array.isArray(this.contract.details)) ? this.contract.details : [];
        const total = details.reduce((sum, item) => {
          const qty = parseFloat(item.qty) || 0;
          const unitPrice = parseFloat(item.unitPrice) || 0;
          return sum + (qty * unitPrice);
        }, 0);
        const valid = Number.isFinite(total) ? total : 0;
        return valid.toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      // 合同明细总价大写
      contractItemsTotalPriceUpper() {
        const details = (this.contract && Array.isArray(this.contract.details)) ? this.contract.details : [];
        const total = details.reduce((sum, item) => {
          const qty = parseFloat(item.qty) || 0;
          const unitPrice = parseFloat(item.unitPrice) || 0;
          return sum + (qty * unitPrice);
        }, 0);
        return toChineseRMB(total);
      },
    },
    mounted() {
      // 如通过 URL 传入 ids，可在此处读取并请求后端数据
      const id = this.$route && this.$route.query && this.$route.query.id;
      if (id) {
        this.fetchData(id);
      }
    },

    methods: {
      fetchData(id) {
        // 示例：根据后端接口调整
        this.$http.get("basic", `sapPurchaseOrders/${id}`).then((res) => {
          if (res && res.success) {
            Object.assign(this.contract, res.data || {});
          }
        }).catch(() => {});
      },
      printHandle() {
        document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
        window.print();
        window.location.reload();
      },
    },
  };
</script>

<style lang="scss" scoped>
.print-template {
  width: 210mm; /* A4宽度 */
  padding: 10mm;
  margin: 0 auto;
  font-family: 'SimSun', '宋体', serif; /* 使用宋体确保中文显示正常 */
  font-size: 10pt; /* 字体大小12pt */
  color: #000; /* 字体颜色#000 */
  box-sizing: border-box;
  border: 1px solid #333; /* 边框颜色#000 */
  
  /* 标题部分 */
  .title-section {
    text-align: center;
    margin-bottom: 10px;
    
    h1 {
      font-size: 16pt;
      font-weight: bold;
      margin: 0 0 10px 0;
    }
    
    h2 {
      font-size: 14pt;
      font-weight: bold;
      margin: 0 0 8mm 0;
    }
    
    .page-number {
      text-align: right;
      margin-top: 5mm;
    }
  }
  
  /* 订单基本信息 */
  .order-info {
    .info-row {
      display: flex;
      justify-content: space-between;
      .info-column {
        width: 32%;
        .info-item {
          margin-bottom: 5px;
        }
      }
    }
  }
  
  /* 物料表格 */
  .material-table {
    table {
      width: 100%;
      border-collapse: collapse;
      
      th,
      td {
        border: 1px solid #000; /* 边框颜色#000 */
        padding: 1px ;
        text-align: center;
        word-break: break-word;
      }
      
      th {
        font-weight: bold;
        background-color: #f5f5f5;
      }
      
      .total-label {
        font-weight: bold;
        text-align: right;
        vertical-align: middle;
      }
      
      .total-value {
        text-align: left;
      }
    }
  }
  
  /* 备注信息 */
  .remarks {
    margin-bottom: 30px;
    
    .remark-item {
      line-height: 1.3;
    }
  }
  
  /* 签字盖章部分 */
  .signature-section {
    display: flex;
    justify-content: space-between;
    
    .signature-column {
      width: 45%;
      
      .signature-title {
        margin-bottom: 2mm;
      }
      
      .signature-area {
        height: 20mm;
        border: 1px solid #000; /* 边框颜色#000 */
        margin-bottom: 5mm;
      }
      
      .signature-info {
        div {
          margin-bottom: 2mm;
        }
      }
    }
  }
}

/* 打印样式调整 */
@media print {
  .printBtn {
    display: none;
  }
  
  .print-template {
    border: none;
    margin: 0 auto;
    padding: 0;
  }
  /* 实现打印页码功能 */
  @page {
    margin: 0.5cm 1.5cm 1.5cm; /* 底部边距要足够大以容纳页脚 */
    counter-increment: page;
    @bottom-center{
      font-size: 10pt;
      color: #000;
      content: "第 " counter(page) " 页 共 " counter(pages) " 页";
    }
  }
}
</style>